<template>
  <div class="content-benefits">
    <div v-for="(benefit, index) in benefits" :key="index" class="content-benefit">
      <img
        v-if="benefit.svg"
        class="content-benefit__icon"
        :src="`data:image/svg+xml,${encodeURIComponent(benefit.svg)}`"
        alt=""
        aria-hidden="true"
      />
      <div class="content-benefit__content">
        <strong v-if="benefit.title">{{ benefit.title }}</strong>
        <p v-if="benefit.text">{{ benefit.text }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ContentBenefit } from '@/ts/types/schema.types'

defineProps<{ benefits?: ContentBenefit[] }>()
</script>

<style lang="scss" scoped>
@import 'a-benefits';
</style>
